import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { FormValues } from '../../types/forms';

interface ClienteFormProps {
    register: UseFormRegister<FormValues>;
    errors: FieldErrors<FormValues>;
    onTelefonoBlur?: (telefono: string) => void; // ← Nueva prop
    // Casilla "Invitar al portal". Solo tiene sentido con correo: sin él no
    // hay a dónde mandar la invitación.
    hayEmail?: boolean;
    invitarPortal?: boolean;
    onInvitarPortalChange?: (invitar: boolean) => void;
}

export const ClienteForm = ({ register, errors, onTelefonoBlur, hayEmail, invitarPortal, onInvitarPortalChange }: ClienteFormProps) => {
    return (
        <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-4">Datos del Cliente</h3>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700">Nombre *</label>
                    <input
                        type="text"
                        {...register("nombre")}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                    />
                    {errors.nombre && <p className="mt-1 text-sm text-red-600">{errors.nombre.message}</p>}
                </div>
                
                <div>
                    <label className="block text-sm font-medium text-gray-700">DNI *</label>
                    <input
                        type="text"
                        {...register("dni")}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                    />
                    {errors.dni && <p className="mt-1 text-sm text-red-600">{errors.dni.message}</p>}
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">Email</label>
                    <input
                        type="email"
                        {...register("email")}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                    />
                    {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>}
                    {onInvitarPortalChange && (hayEmail ? (
                        <label className="mt-2 flex items-center gap-2 text-sm text-gray-700">
                            <input
                                type="checkbox"
                                checked={!!invitarPortal}
                                onChange={(e) => onInvitarPortalChange(e.target.checked)}
                            />
                            Invitar al portal del cliente
                        </label>
                    ) : (
                        <p className="mt-1 text-xs text-gray-500">
                            Sin correo no tendrá acceso al portal ni recibirá avisos por email.
                        </p>
                    ))}
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">Teléfono *</label>
                    <input
                        type="text"
                        {...register("telefono")}
                        onBlur={(e) => onTelefonoBlur?.(e.target.value)} // ← Agregar onBlur
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                    />
                    {errors.telefono && <p className="mt-1 text-sm text-red-600">{errors.telefono.message}</p>}
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Fecha de Nacimiento <span className="text-gray-400 font-normal">(opcional)</span>
                    </label>
                    <input
                        type="date"
                        {...register("fechaNacimiento")}
                        max={new Date().toISOString().split('T')[0]}
                        min="1900-01-01"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                    />
                    {errors.fechaNacimiento && <p className="mt-1 text-sm text-red-600">{errors.fechaNacimiento.message}</p>}
                </div>

                <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700">Observaciones</label>
                    <textarea
                        {...register("observaciones")}
                        rows={3}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                    />
                </div>
            </div>
        </div>
    );
};


